// Copyright (c) StrangeBee 2023

import { Route as AlertsLayoutRoute } from './Details';
import { Route as AlertsListRoute } from './List';

export const Routes = [AlertsLayoutRoute, AlertsListRoute];
